module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/mensaje/mensaje.component.css
// module id = ./src/app/components/mensaje/mensaje.component.css
// module chunks = main